import React from 'react';

const RoomContext = React.createContext();

export default RoomContext;

export function withRoomContext(Component) {
  const WrapperComponent = (
    props // eslint-disable-line react/display-name
  ) => (
      <RoomContext.Consumer>
        {(roomClient) => <Component {...props} roomClient={roomClient} />}
      </RoomContext.Consumer>
    );

  return WrapperComponent;
}
